import { withStore } from 'common/src/vtj/mobx/action-creator'
import { MobXProviderContext } from 'mobx-react'
import React from 'react'
import { TodistuksetUi } from 'todistukset-ui/src/vtj/common-types'

export const useStore = (): TodistuksetUi.Store =>
  React.useContext(MobXProviderContext).store

/**
 * @deprecated prefer using useStore hook, which uses context to get store.
 * */
export const getStore = (): TodistuksetUi.Store =>
  withStore((store: TodistuksetUi.Store) => store)
